module.exports = __webpack_public_path__ + "static/media/leader.cd028f25.jpg";